import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ModuleFE_Dialog, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_EditChildrenOrder.scss';
import { sortArray } from '@nu-art/ts-common';
import { Tooltip_Information } from '../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { ConfigKeyFE_TagsOrder, ModuleFE_Tag } from '../../../_entity.js';
import { RootTag } from '@app/hcs-shared/core';
export class Dialog_EditChildrenOrder extends TS_Dialog {
    // ######################### Class Variables #########################
    draggedItemIndex = { current: null };
    draggedOverItemIndex = { current: null };
    // ######################### Static #########################
    static defaultProps = {
        dialogId: 'dialog-edit-children-order',
    };
    static show(parentCategoryId = RootTag) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_EditChildrenOrder, { parentCategoryId: parentCategoryId }), closeOverlayOnClick: () => true });
    }
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        const config = ConfigKeyFE_TagsOrder.get();
        if (nextProps.parentCategoryId === RootTag) {
            state.categories = ModuleFE_Tag.cache.filter(cat => cat.tagIds.length === 0);
        }
        else {
            state.categories = ModuleFE_Tag.cache.filter(cat => cat.tagIds[cat.tagIds.length - 1] === nextProps.parentCategoryId);
        }
        if (config) {
            const childrenOrder = config[nextProps.parentCategoryId];
            if (childrenOrder)
                state.categories = sortArray(state.categories, (category) => childrenOrder.indexOf(category._id));
        }
        return state;
    }
    // ######################### Logic #########################
    canBeSaved = () => {
        return true;
    };
    handleSave = async () => {
        const config = ConfigKeyFE_TagsOrder.get() || {};
        config[this.props.parentCategoryId] = this.state.categories.map(category => category._id);
        await ConfigKeyFE_TagsOrder.set(config);
        ModuleFE_Dialog.close();
    };
    onDragStart = (e, rowIndex) => {
        this.draggedItemIndex.current = rowIndex;
    };
    onDragEnter = (e, rowIndex) => {
        if (this.draggedItemIndex.current === null)
            return;
        this.draggedOverItemIndex.current = rowIndex;
        const listCopy = [...this.state.categories];
        const draggingItemContent = listCopy[this.draggedItemIndex.current];
        listCopy.splice(this.draggedItemIndex.current, 1);
        listCopy.splice(this.draggedOverItemIndex.current, 0, draggingItemContent);
        this.draggedItemIndex.current = this.draggedOverItemIndex.current;
        this.draggedOverItemIndex.current = null;
        this.setState({ categories: listCopy });
    };
    onDragEnd = (e) => {
        this.draggedItemIndex = { current: null };
        this.forceUpdate();
    };
    // ######################### Render #########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'header__title', children: "Edit Categories Order" }), _jsxs("div", { className: 'header__buttons', children: [_jsx(Tooltip_Information, { title: 'Edit Categories Order', paragraphs: ['Hold click and drag any category to position it.', 'Click save when done.'] }), _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() })] })] });
    };
    renderBody = () => {
        if (!this.state?.categories)
            return '';
        return _jsx(_Fragment, { children: this.state.categories.map((category, i) => {
                const className = _className('item', i === this.draggedItemIndex.current ? 'dragged' : undefined);
                return _jsxs("div", { className: className, draggable: 'true', onDragStart: (e) => this.onDragStart(e, i), onDragOver: (e) => e.preventDefault(), onDragEnter: (e) => this.onDragEnter(e, i), onDragEnd: this.onDragEnd, children: [i + 1, ". ", category.label] }, i);
            }) });
    };
    buttons = () => {
        return {
            right: [
                { content: 'Cancel', onClick: () => this.closeDialog() },
                {
                    content: 'Save',
                    onClick: this.handleSave,
                    disabled: !this.canBeSaved(),
                    className: this.canBeSaved() ? 'desired-action-button' : undefined,
                }
            ]
        };
    };
}
//# sourceMappingURL=Dialog_EditChildrenOrder.js.map